import React, { useEffect, useState } from 'react';
import './SessionTimeoutModal.scss';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  secondsRemaining: number;
  onContinue: () => void;
  onLogout: () => void;
}

export const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  isOpen,
  secondsRemaining,
  onContinue,
  onLogout,
}) => {
  const [countdown, setCountdown] = useState(secondsRemaining);

  useEffect(() => {
    if (!isOpen) return;

    setCountdown(secondsRemaining);

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onLogout(); // Auto-logout when countdown reaches 0
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, secondsRemaining, onLogout]);

  if (!isOpen) return null;

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;

  return (
    <div className="session-timeout-overlay">
      <div className="session-timeout-modal">
        <div className="modal-icon">⏰</div>
        <h2>Are You Still There?</h2>
        <p className="modal-message">
          Your session is about to expire due to inactivity.
        </p>
        <div className="countdown-display">
          <span className="countdown-time">
            {minutes}:{seconds.toString().padStart(2, '0')}
          </span>
          <span className="countdown-label">remaining</span>
        </div>
        <p className="modal-info">
          Click "Continue" to stay logged in, or you'll be automatically logged out.
        </p>
        <div className="modal-actions">
          <button className="logout-btn" onClick={onLogout} type="button">
            Logout Now
          </button>
          <button className="continue-btn" onClick={onContinue} type="button">
            Continue Session
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
